<div class="my-journal-wrapper md:mt-[0] mt-[2rem]" *ngIf="!showDisclaimerBlock">
  <div class="my-journal-heading-wrapper">
    <app-weeks-heading></app-weeks-heading>
  </div>
  <div class="my-journal-week-list-wrapper">
    <app-week-list-toggle
      [weekList]="weekListToggleData.weekList"
      [loading]="weekListToggleData.loading"
      [selectedDate]="weekListToggleData.selectedDate"
      (selectedDayEmitter)="onSelectedDayChanged($event)"></app-week-list-toggle>
  </div>
  <div class="daily-food-tracker" *ngIf="showDetailsForAdult ||
  selectedDate?.lastSession >= 2">
    <app-daily-meal-drink-tracker *ngIf="!weekListToggleData.loading"
                                  [memberId]="memberId"
      [selectedDate]="selectedDate" [groupId]="memberId  ? selectedGroupId : groupId"></app-daily-meal-drink-tracker>
  </div>
  <div class="daily-food-tracker" *ngIf="showDetailsForAdult ||
  selectedDate?.lastSession >= 8">
    <app-daily-physical-activity-tracker *ngIf="!weekListToggleData.loading"
      [memberId]="memberId"
      [selectedDate]="selectedDate"
      [groupId]="memberId  ? selectedGroupId : groupId"
      ></app-daily-physical-activity-tracker>
  </div>
  <div class="screen-time-tracker-wrapper" *ngIf="showDetailsForAdult ||
  selectedDate?.lastSession >= 15">
    <app-screen-time-tracker *ngIf="!weekListToggleData.loading"
      [memberId]="memberId"
      [selectedDate]="selectedDate"
      [groupId]="memberId  ? selectedGroupId : groupId"
      ></app-screen-time-tracker>
  </div>
</div>


<div *ngIf="showDisclaimerBlock" class='disclaimer-block-wrapper'>
  <div class="flex flex-row space-x-[1rem]">
    <app-icon svgIcon="exclamation-circle"></app-icon>
    <div class="error-message">
      You or your participants are not part of any group.
    </div>
  </div>
</div>
